import React from 'react';
import { classes } from '../CUtil';

const OurLogo = (props) => {
	const cls = classes("ad_navbar_brand_logo", props.className);
	let alt, src;
	const dark = !!props.dark;

	if (IS_BT || IS_EUROINVESTOR || IS_BERLINGSKE || IS_TEST) {
		alt = "Aktiedysten";;
		src = dark ? "https://aktiedysten-static-v2.s3.eu-north-1.amazonaws.com/gfx/millionaerklubbens-aktiespil-header.svg" : "https://aktiedysten-static-v2.s3.eu-north-1.amazonaws.com/gfx/millionaerklubbens-aktiespil-header.svg";
	}
	return <img alt={alt} className={cls} src={src}/>;
}

export default OurLogo;



// WEBPACK FOOTER //
// ./src/c/OurLogo.js